import React, {useRef, useState} from 'react';
import "./AddEmployeeForm.css";
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";
import CustomAlert from "../../../components/ConfirmationModal/CustomAlert";
import PartnerDeleter from "./PartnerDeleter";

const AddPartnerForm = () => {
    const fileInputRef = useRef(null);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertType, setAlertType] = useState(''); // 'success' or 'error'
    const [showAlert, setShowAlert] = useState(false)
    const [updateKey, setUpdateKey] = useState(0);
    const [fileName, setFileName] = useState('');
    const [fileURL, setFileURL] = useState('');
    const [fileInputKey, setFileInputKey] = useState(0);
    const [formData, setFormData] = useState({
        fullName: '',
        position: '',
        desctiprion: '',
        file: {
            base64String: '',
            ext: ''
        },
        fullNameEng: '',
        positionEng: '',
        desctiprionEng: '',
        url: '',
    });

    const resetFileInput = () => {
        setFileInputKey(prevKey => prevKey + 1); // Increment the key to force re-render
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };



    const resetForm = () => {
        setFormData({
            fullName: '',
            position: '',
            desctiprion: '',
            file: {
                base64String: '',
                ext: ''
            },
            fullNameEng: '',
            positionEng: '',
            desctiprionEng: '',
            url: '',
        });
        setFileName('');
        setFileURL('');
    };

    const handleInputChange = (e) => {
        if (e.target.name === 'file') {
            handleFileChange(e);
        } else {
            setFormData({ ...formData, [e.target.name]: e.target.value });
        }
    };
    const isFormComplete = () => {
        return formData.fullName.trim() !== '' &&
            formData.fullNameEng.trim() !== '' &&
            fileName !== '';
    };


    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file && (file.type === "image/png" || file.type === "image/jpeg")) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setFormData({
                    ...formData,
                    file: {
                        base64String: reader.result.split(',')[1], // Remove the data URL part
                        ext: file.name.split('.').pop(),
                    }
                });
            };
            reader.readAsDataURL(file);

            setFileName(file.name);
            setFileURL(URL.createObjectURL(file));
        } else {
            alert('არაწორი ფორმატი');
        }

        // Reset the file input
        resetFileInput();

    };


    const handleDeleteImage = () => {
        setFileName('');
        setFileURL('');
        setFormData({ ...formData, file: { base64String: '', ext: '' } });
        resetFileInput();

    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsModalOpen(true);
    };

    const handleConfirm = async () => {
        setIsModalOpen(false);

        // Extract the JWT token
        const jwtToken = localStorage.getItem('jwtToken');
        if (!jwtToken) {
            setAlertMessage('JWT Token is missing');
            setAlertType('error');
            setShowAlert(true);
            return;
        }


        try {
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/AddPartner`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${jwtToken}`
                },
                body: JSON.stringify(formData)
            });
            // Handling the response
            if (response.ok) {
                resetFileInput();
                setUpdateKey(prev => prev + 1);
                const result = await response.json();
                resetForm();
                setAlertMessage('ოპერაცია წარმატებით დასრულდა');
                setAlertType('success');
            } else {
                setAlertMessage('დაფიქსირდა შეცდომა, ცადეთ მოგივანებით');
                setAlertType('error');
            }
        } catch (error) {
            setAlertMessage('Error submitting form');
            setAlertType('error');
        }
        setShowAlert(true);
    };

    return (

        <div className="employee-form-wrapper">
            <h1 className="employee-form-title">პარტნიორი კომპანიის დამატება</h1>
            <form onSubmit={handleSubmit} className="employee-form">
                <input
                    type="text"
                    name="fullName"
                    value={formData.fullName}
                    onChange={handleInputChange}
                    placeholder="კომპანიის სახელი"
                    className="employee-input"
                />

                <input
                    type="text"
                    name="fullNameEng"
                    value={formData.fullNameEng}
                    onChange={handleInputChange}
                    placeholder="კომპანიის სახელი (ინგლისურად)"
                    className="employee-input"
                />
                <input
                    type="text"
                    name="url"
                    value={formData.url}
                    onChange={handleInputChange}
                    placeholder="კომპანიის URL"
                    className="employee-input"
                />

                <label htmlFor="file-upload" className="custom-file-upload">
                    {fileName || 'სურათის ატვირთვა (png, jpg)'}
                </label>
                {fileName && (
                    <div className={"euro-button-container"}>
                        <a href={fileURL} target="_blank" rel="noopener noreferrer" className="file-preview-link">
                            სურათის ნახვა
                        </a>
                        <button onClick={handleDeleteImage} className="delete-image-button">
                            სურათის წაშლა
                        </button>
                    </div>
                )}

                <input
                    key={fileInputKey}
                    id="file-upload"
                    type="file"
                    name="file"
                    onChange={handleInputChange}
                    accept=".png,.jpg"
                    className="employee-file-input"/>
                <button type="submit" className="employee-submit-button" disabled={!isFormComplete()}>
                    კომპანიის დამატება
                </button>
            </form>
            <h1 className="employee-form-title">კომპანიის წაშლა</h1>

            <PartnerDeleter updateKey={updateKey}/>
            <ConfirmationModal
                isOpen={isModalOpen}
                onRequestClose={() => setIsModalOpen(false)}
                onConfirm={handleConfirm}
            />
            {showAlert && (
                <CustomAlert
                    message={alertMessage}
                    type={alertType}
                    onClose={() => setShowAlert(false)}
                />
            )}
        </div>
    );
};

export default AddPartnerForm;
